module.exports = __webpack_public_path__ + "static/img/part2.762d1ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/part2.png
// module id = Tk6U
// module chunks = 0